import { useSyncExternalStore } from "react"
import { getFontLoadVersion, subscribeToFontLoading } from "../helpers/font-loading"

export function useRelayoutOnFontLoad(): void {
  useSyncExternalStore(subscribeToFontLoading, getFontLoadVersion)
}
